module.exports = kfplatform;